module.exports = __webpack_public_path__ + "media/images/icons/email_dark-2fba099cc822b73b4e01aeba8f54f6bf.svg";